import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Button, Flex, Input, useColorModeValue, Text } from "@chakra-ui/react";

function Dropzone({ content, value, onChange, error, required = false, ...rest }) {
  const bg = useColorModeValue("gray.100", "navy.700");
  const brandStars = useColorModeValue("red.500", "red.400");
  const borderColor = useColorModeValue("gray.300", "whiteAlpha.100");
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0 && onChange) {
        onChange(acceptedFiles[0]);
      }
    },
    [onChange]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "text/csv": []
    },
    multiple: true,
  });

  return (
    <>
      <Flex
        align='center'
        justify='center'
        bg={bg}
        border='1px dashed'
        borderColor={borderColor}
        borderRadius='16px'
        w='100%'
        maxW='100%'
        h='max-content'
        minH='130px'
        cursor='pointer'
        direction='column'
        {...getRootProps({ className: "dropzone" })}
        pt='80px !important'
        pb='105px !important'
        {...rest}
      >
        <Input type='file' {...getInputProps()} />
        <Button variant='no-effects'>{content}</Button>
        {isDragActive && (
          <Text mt={2} fontSize='sm' color='blue.500'>
            Drop the CSV file here...
          </Text>
        )}
      </Flex>
      {value && (
        <Text as="span" fontWeight="500" fontSize='l' color={textColor}>
          Selected file: {' '}
          <Text
            as="span"
            fontSize="l"
            fontWeight="500"
            color='#fa8f03'
          >
            {value.name}
          </Text>
        </Text>
      )}
      {error && required && (
        <Text as="span" color={brandStars}>
          Please upload a CSV file.
        </Text>
      )}
    </>
  );
}

export default Dropzone;
